export function useCropText(text: string, maxLength: number, endChars = "...") {
  if (!text) return "";
  if (text.length <= maxLength) return text;

  return `${text.substring(0, maxLength)}${endChars}`;
}
